import { createReducer } from '@reduxjs/toolkit';
import { OrgProfileState, OrgProfileUpdateState } from './types';
import { fetchProfile, updateProfile } from './actions';

const initialOrgProfileState: OrgProfileState = {
  profile: null,
  loading: false,
  error: null,
};

const initialOrgProfileUpdateState: OrgProfileUpdateState = {
  message: null,
  loading: false,
  error: null,
};

export const updateOrgProfileReducer = createReducer(initialOrgProfileUpdateState, (builder) => {
  builder
    .addCase(updateProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload;
    })
    .addCase(updateProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const orgProfileReducer = createReducer(initialOrgProfileState, (builder) => {
  builder
    .addCase(fetchProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.profile = action.payload;
    })
    .addCase(fetchProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});
